import isObject from 'lodash-es/isObject';
import camelCase from 'lodash-es/camelCase';
import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';
import { registry } from 'lcc-state';
import { Title } from './title';
import css from '@holmescorp/book-widgets/css/topicpage.m.css';
const skipElements = new Set(['prolog', 'draft-comment', 'indexterm']);
const possiblySilly = new Set(['p', 'b', 'i']);
const factory = create({ theme }).properties();
export const GenerateItem = factory(({ properties, middleware: { theme } }) => {
    const { item, compconn = false, additionalClasses = {} } = properties();
    const themeCss = theme.classes(css);
    let name = Object.keys(item)[0];
    const originalName = name;
    const itemIsArray = Array.isArray(item);
    const itemIsString = typeof item === 'string';
    const itemIsNumber = typeof item === 'number';
    if (itemIsArray || itemIsString || itemIsNumber) {
        name = 'span';
    }
    const value = itemIsArray
        ? item[0]
        : itemIsString
            ? item
            : itemIsNumber
                ? `${item}`
                : item[name];
    if (skipElements.has(name)) {
        return null;
    }
    const classes = [];
    const eleitem = item[name];
    const attrs = eleitem && eleitem.attributes ? eleitem.attributes : undefined;
    if (attrs && attrs.outputclass) {
        classes.push(attrs.outputclass);
    }
    if (attrs && attrs.props && isObject(value) && isObject(value.attributes)) {
        const splitProps = attrs.props.match(/[a-zA-Z_]+/g);
        if (splitProps && splitProps.length === 2) {
            const newWidget = camelCase(splitProps[1]);
            value.attributes['widget'] = newWidget;
            name = newWidget;
        }
    }
    if (name === 'ul') {
        const ulitem = item.ul;
        const attrs = ulitem.attributes;
        if (attrs && attrs.outputclass) {
            switch (attrs.outputclass) {
                case 'HCBullet':
                    classes.push(themeCss.HCBullet);
                    break;
                case 'HCBulletStyle2':
                    classes.push(themeCss.HCBulletStyle2);
                    break;
                case 'TableUL':
                    classes.push(themeCss.TableUL);
                    break;
            }
        }
    }
    else if (name === 'sectiondiv') {
        name = 'section';
    }
    if (name in additionalClasses) {
        classes.push(...additionalClasses[name]);
    }
    if (registry.has(name)) {
        if (name === 'title') {
            return w(Title, { title: value, insection: true });
        }
        else {
            return w(name, {
                compconn,
                topicdata: value,
                additionalClasses: classes,
                originalName
            });
        }
    }
    if (typeof value === 'string') {
        return v(name, { classes }, [value]);
    }
    else if (typeof value === 'number') {
        return v(name, { classes }, [`${value}`]);
    }
    else if (typeof value.children === 'string') {
        return v(name, { classes }, [value.children]);
    }
    else if (typeof value.children === 'number') {
        return v(name, { classes }, [`${value.children}`]);
    }
    else if (Array.isArray(value.children)) {
        const kids = value.children.map((val) => {
            if (typeof val === 'string') {
                return val;
            }
            if (typeof val === 'number') {
                return `${val}`;
            }
            return w(GenerateItem, { item: val, compconn });
        });
        return v(name, { classes }, kids);
    }
    else if (isObject(value)) {
        if (possiblySilly.has(name) && value.attributes && !value.children) {
            return null;
        }
        const kids = w(GenerateItem, { item: value, compconn });
        return v(name, { classes }, Array.isArray(kids) ? kids : [kids]);
    }
    return v(name, { classes }, []);
});
